const appCode = 'ec-pc-new'
// 请求cookie键名
const Authorizition = 'accessToken'
// 会话过期错误码
const TOKEN_EXPIRED_CODE = 10001;

const domain = window.location.origin;
// 接口baseURL
const baseUrl = process.env.BUILD_ENV === 'local' ? '/api' : `${domain}/gw/`;
const httpUrl = `${domain}/`;

const numberCompareEnum = {
  greater: '>',        // 大于
  less: '<',           // 小于
  equal: '=',          // 等于
  greaterOrEqual: '>=', // 大于等于
  lessOrEqual: '<=',    // 小于等于
  notEqual: '!=',       // 不等于
  range: 'between'          // 介于A-B
}

const newProductStepEnum = {
  create: 100,       // 创建SKU
  newArrival: 101,   // 新品上架
  sampleGroup: 102,  // 样品组货
  shooting: 103,     // 拍摄
  retouching: 104,   // 修片
  files: 105,        // 产品资料
  paperwork: 106,    // 产品文案
  design: 107,       // 设计
  sectioning: 108,   // 切片
  preparation: 109,  // 准备上架
  finished: 110,     // 完成上架
  render: 111        // 渲染
}

export { appCode, Authorizition, baseUrl, httpUrl, TOKEN_EXPIRED_CODE, numberCompareEnum, newProductStepEnum }
